document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.sorting-filter__label').forEach(function (label) {
      label.textContent = label.textContent.replace('Alphabetically', 'SKU');
    });
  });

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.sorting-filter__select option').forEach(function (option) {
    option.textContent = option.textContent
      .replace('Alphabetically, A-Z', 'SKU, A-Z')
      .replace('Alphabetically, Z-A', 'SKU, Z-A');
  });
});

const productGrid = document.querySelector(".product-grid");

if (productGrid) {
  productGrid.style.visibility = "hidden";
}
console.log("CUSTOM PRODUCT SCRIPT LOADED", window.location.href);


document.addEventListener("DOMContentLoaded", () => {

 if (
  !location.pathname.includes("/collections/") &&
  !location.pathname.includes("/search")
) return;


  const grid = document.querySelector(".product-grid");
  if (!grid) return;

  const cards = [...grid.querySelectorAll("li")];
  const output = [];




  // -----------------------------------
  // COLLECTION CHECK
  // -----------------------------------
  const isBedCollection = [
    "/collections/bed",
    "/collections/beds",
    "/collections/bedroom",
    "/collections/bedroom-sets",
    "/collections/upholstered-beds"
  ].some(path => location.pathname.includes(path));

  console.log("IS BED COLLECTION:", isBedCollection);

  // -----------------------------------
  // GET URL PARAMS
  // -----------------------------------
  const params = new URLSearchParams(window.location.search);
const searchQuery = (params.get("q") || "")
  .trim()
  .toLowerCase();

console.log("SEARCH QUERY:", searchQuery);
  // -----------------------------------
  // GET ACTIVE COLOR FILTERS
  // -----------------------------------
  const activeColors = params
    .getAll("filter.v.option.color")
    .map(color =>
      decodeURIComponent(color)
        .replace(/\+/g, " ")
        .trim()
        .toLowerCase()
    );

  console.log("ACTIVE COLORS:", activeColors);

  // -----------------------------------
  // GET ACTIVE AVAILABILITY FILTERS
  // -----------------------------------
  const activeAvailability = params
    .getAll("filter.v.availability")
    .map(v => v.trim());

  console.log("ACTIVE AVAILABILITY:", activeAvailability);

  const showAvailable = activeAvailability.includes("1");
  const showSoldOut = activeAvailability.includes("0");

  // -----------------------------------
  // BUILD VARIANT CARDS
  // -----------------------------------
  cards.forEach(card => {

    const dataEl = card.querySelector(".variant-data");
    if (!dataEl) return;

    let variants = [];

    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      console.log("JSON ERROR:", e);
      return;
    }
// -----------------------------------
// SEARCH: ONLY SHOW MATCHING VARIANT
// -----------------------------------
if (searchQuery) {
  const matchingVariants = variants.filter(v => {
    const sku = (v.sku || "").trim().toLowerCase();

    return sku === searchQuery;
  });

  if (matchingVariants.length > 0) {
    variants = matchingVariants;
  }
}
    // -----------------------------------
    // GROUP BY COLOR
    // -----------------------------------
    const colorMap = {};

    variants.forEach(v => {

      if (!v.variantTitle) return;

      let size = "";
      let color = "";

      if (v.bundleColor) {
        color = v.bundleColor;
         v.productOptions?.forEach((optionName, index) => {
          if (optionName.toLowerCase() === "size") {
            size = v.options[index];
          }
          });
      } else {
        v.productOptions?.forEach((optionName, index) => {
          if (optionName.toLowerCase() === "size") {
            size = v.options[index];
          }
          if (optionName.toLowerCase() === "color") {
            color = v.options[index];
          }
        });
      }

      // -----------------------------------
      // FILTER ONLY SELECTED COLORS
      // -----------------------------------
      if (
        activeColors.length &&
        !activeColors.includes((color || "").trim().toLowerCase())
      ) {
        return;
      }

      // -----------------------------------
      // FILTER BY AVAILABILITY
      // -----------------------------------
      if (activeAvailability.length) {
        if (showAvailable && !showSoldOut && !v.available) {
          return;
        }
        if (showSoldOut && !showAvailable && v.available) {
          return;
        }
      }

      // -----------------------------------
      // CREATE COLOR GROUP
      // -----------------------------------
      if (!colorMap[color]) {
        colorMap[color] = {
          color,
          image: v.image,
          url: v.url,
          productTitle: v.productTitle,
          sku: v.sku,
          variants: [],
          sizes: [],
          productDisplay: ""
        };
      }

      // -----------------------------------
      // PRODUCT DISPLAY
      // -----------------------------------
      const displayValue = (v.productDisplay || "").toLowerCase();

      if (displayValue === "first") {
        colorMap[color].productDisplay = "first";
      }

      if (displayValue === "last") {
        colorMap[color].productDisplay = "last";
      }

      colorMap[color].variants.push(v);

      if (size && !colorMap[color].sizes.includes(size)) {
        colorMap[color].sizes.push(size);
      }
    });

    // -----------------------------------
    // CREATE CARD PER COLOR
    // -----------------------------------
    Object.values(colorMap).forEach(item => {

      const clone = card.cloneNode(true);

      clone.dataset.productDisplay = item.productDisplay || "";

      
      const queenVariants = item.variants.filter(v => {
  const titleParts = (v.variantTitle || "").split("/");
  const sizeOption = titleParts[titleParts.length - 1];

  return sizeOption.trim().toLowerCase().includes("queen");
});

const isQueenAvailable = queenVariants.some(v => v.available === true);
const hasAvailableVariant = item.variants.some(v => v.available === true);

if (isBedCollection) {
  if (queenVariants.length > 0) {
    // If product has a Queen size, treat as in-stock ONLY if Queen is available
    clone.dataset.queenInStock = isQueenAvailable ? "true" : "false";
    clone.dataset.available = isQueenAvailable ? "true" : "false";
  } else {
    // If no Queen size exists, fall back to general stock availability
    clone.dataset.queenInStock = "false";
    clone.dataset.available = hasAvailableVariant ? "true" : "false";
  }
} else {
  clone.dataset.queenInStock = "false";
  clone.dataset.available = hasAvailableVariant ? "true" : "false";
}



      // -----------------------------------
      // LINKS
      // -----------------------------------
      clone.querySelectorAll("a").forEach(a => {
        a.setAttribute("href", item.url);

        a.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          window.location.href = item.url;
        }, true);
      });

      // -----------------------------------
      // IMAGE
      // -----------------------------------
      const img =
        clone.querySelector(".product-media__image") ||
        clone.querySelector("img");

      if (img && item.image) {
        img.src = item.image.startsWith("//")
          ? "https:" + item.image
          : item.image;
        img.removeAttribute("srcset");
      }

      // -----------------------------------
      // TITLE
      // -----------------------------------
      const title =
        clone.querySelector('p[role="heading"]') ||
        clone.querySelector("h3");

      if (title) {
        title.textContent = item.color
          ? `${item.productTitle}, ${item.color}`
          : item.productTitle;
      }

      // -----------------------------------
      // SKU + SIZE
      // -----------------------------------
      const skuComponent = clone.querySelector("product-sku-component");

      if (skuComponent) {
        const skuSpan = skuComponent.querySelector(".sku");

        if (skuSpan) {
          let sku = item.sku || "";

          const trimSkuCollections = [
            "/collections/beds",
            "/collections/upholstered-beds",
            "/collections/headboards",
            "/collections/bedroom-sets"
          ];

          const shouldTrimSku = trimSkuCollections.some(path =>
            window.location.pathname.includes(path)
          );

          if (shouldTrimSku && sku) {
            sku = sku.split("-")[0];
          }

          skuSpan.textContent = sku ? ` ${sku}` : "";
        }

        let sizeEl = skuComponent.querySelector(".size");

        if (!sizeEl) {
          sizeEl = document.createElement("div");
          sizeEl.className = "size";
          skuComponent.appendChild(sizeEl);
        }

        const cleanSizes = item.sizes.filter(
          s => s && s !== "Default Title"
        );

        sizeEl.textContent = cleanSizes.length
          ? `Sizes: ${cleanSizes.join(", ")}`
          : "";
      }

      // -----------------------------------
      // WISHLIST
      // -----------------------------------
      const wishlistBtn = clone.querySelector(".product-card-wishlist-btn");
      if (wishlistBtn) {
        wishlistBtn.setAttribute("data-variant-id", item.sku || item.url);
      }

      // -----------------------------------
      // SOLD OUT BADGE LOGIC
      // -----------------------------------
      if (clone.dataset.available === "false") {
        let badgeContainer = clone.querySelector(".product-badges");

        if (!badgeContainer) {
          const gallery = clone.querySelector(".card-gallery");
          badgeContainer = document.createElement("div");
          badgeContainer.className = "product-badges product-badges--top-right";
          gallery?.appendChild(badgeContainer);
        }

        const alreadyHasSoldOut = [...badgeContainer.querySelectorAll(".product-badges__badge")]
          .some(badge => badge.textContent.trim().toLowerCase() === "sold out");

        if (!alreadyHasSoldOut) {
          const badge = document.createElement("div");
          badge.className = "product-badges__badge product-badges__badge--rectangle color-scheme-3";
          badge.textContent = "Sold out";
          badgeContainer.appendChild(badge);
        }
      }

      output.push(clone);
    });

    card.remove();
  });

  // -----------------------------------
  // RENDER INITIAL OUTPUT
  // -----------------------------------
  grid.append(...output);

  
function reorderCards() {
  const allCards = [...grid.children];

  const sortAZ = (a, b) => {
    const parseSku = (el) => {
      const rawSku = (el.querySelector("product-sku-component .sku")?.textContent || "")
        .replace(/[^a-zA-Z0-9-]/g, "")
        .toUpperCase()
        .trim();

      const match = rawSku.match(/^([A-Z]+)(0*)(\d+)(.*)$/);

      if (!match) {
        return {
          prefix: rawSku,
          zeroCount: 0,
          val: 0,
          suffix: ""
        };
      }

      const [, prefix, zeros, digits, suffix] = match;

      return {
        prefix,
        zeroCount: zeros.length,
        val: parseInt(digits, 10),
        suffix
      };
    };

    const itemA = parseSku(a);
    const itemB = parseSku(b);

    if (itemA.prefix !== itemB.prefix) {
      return itemA.prefix.localeCompare(itemB.prefix);
    }

    if (itemA.zeroCount !== itemB.zeroCount) {
      return itemB.zeroCount - itemA.zeroCount;
    }

    if (itemA.val !== itemB.val) {
      return itemA.val - itemB.val;
    }

    return itemA.suffix.localeCompare(itemB.suffix);
  };


  // -----------------------------------
  // CHECK SHOPIFY SORT
  // -----------------------------------
  const sortBy = new URLSearchParams(window.location.search).get("sort_by");

  console.log("SHOPIFY SORT:", sortBy);


  // -----------------------------------
  // SHOPIFY SORT SELECTED
  // -----------------------------------
  // Ignore:
  // - first
  // - last
  // - queen in stock
  // - sold out
  // - availability priority
  //
  // ONLY SORT BY SKU
  // -----------------------------------
  if (sortBy) {

    const sortFunction =
      sortBy === "title-descending"
        ? (a, b) => sortAZ(b, a)
        : sortAZ;

    allCards.sort(sortFunction);

    grid.innerHTML = "";
    grid.append(...allCards);

    console.log("Shopify sort selected → SKU sorting only");

    return;
  }


  // -----------------------------------
  // NO SHOPIFY SORT SELECTED
  // -----------------------------------
  // Keep your existing custom priority
  // -----------------------------------

  const firstCards = [];
  const queenInStockCards = [];
  const normalCards = [];
  const soldOutCards = [];
  const lastCards = [];

  allCards.forEach(card => {

    const productDisplay =
      (card.dataset.productDisplay || "").toLowerCase();

    const isAvailable =
      (card.dataset.available || "true") === "true";

    const isQueenInStock =
      card.dataset.queenInStock === "true";


    // FIRST
    if (productDisplay === "first") {
      firstCards.push(card);
      return;
    }


    // LAST
    if (productDisplay === "last") {
      lastCards.push(card);
      return;
    }


    // SOLD OUT
    if (!isAvailable) {
      soldOutCards.push(card);
      return;
    }


    // QUEEN IN STOCK
    if (isQueenInStock) {
      queenInStockCards.push(card);
      return;
    }


    // NORMAL
    normalCards.push(card);
  });


  // Sort each bucket by SKU
  firstCards.sort(sortAZ);
  queenInStockCards.sort(sortAZ);
  normalCards.sort(sortAZ);
  soldOutCards.sort(sortAZ);
  lastCards.sort(sortAZ);


  // -----------------------------------
  // FINAL CUSTOM ORDER
  // -----------------------------------

  grid.innerHTML = "";

  grid.append(
    ...firstCards,
    ...queenInStockCards,
    ...normalCards,
    ...soldOutCards,
    ...lastCards
  );

  console.log("No Shopify sort → custom priority + SKU sorting");
}

  //const sortByParam = params.get("sort_by");

  // Only run reorderCards if no custom sort_by parameter is set in the URL
  //if (!sortByParam) {
    reorderCards();
    grid.classList.add("is-sorted");
  //} else {
   // console.log("Custom Shopify sort active (" + sortByParam + "). Skipping custom JS reorder.");
  //}

});




  // -----------------------------------
  // BLOCK SLIDESHOW ARROWS
  // -----------------------------------
  document.addEventListener('click', (e) => {

    const path = e.composedPath();

    const isArrow = path.some(el =>
      el?.classList?.contains('slideshow-control')
    );

    if (isArrow) {

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
    }

  }, true);

document.addEventListener("click", (e) => {

  const clearBtn = e.target.closest(
    ".clear-filter, .facets__clear-all-link"
  );

  if (!clearBtn) return;

  // let native behavior run first (if any)
  setTimeout(() => {
    window.location.reload();
  }, 50);

});


document.addEventListener("product:variant:change", function(event) {
  console.log("change");

  const variant = event.detail.variant;
  if (!variant) return;

  const dimensionsEl = document.querySelector(".product-dimensions");
  if (!dimensionsEl) return;

  const height = variant.metafields?.custom?.height;
  const width = variant.metafields?.custom?.width_left_to_right;
  const depth = variant.metafields?.custom?.deep_front_to_back;

  if (height && width && depth) {
    dimensionsEl.innerHTML =
      `Overall Dimensions: ${height}"H × ${width}"W × ${depth}"D`;
  } else {
    dimensionsEl.innerHTML = "";
  }
});


document.addEventListener("change", (e) => {

  const target = e.target;

  if (
    !target.matches(
      'input[name="filter.v.option.color"], input[name="filter.v.availability"], input[name="filter.v.option.size"], input[name="sort_by"]'
    )
  ) return;

  setTimeout(() => {
    window.location.href = window.location.href;
  }, 50);

});


  if (window.location.pathname === '/cart') {
    window.location.href = '/';
  }





 document.addEventListener('DOMContentLoaded', function () {
  const link = document.querySelector('.ai-header-nav-list-aege5mgtlz1jrk2x3caigenblock8d9cf99nieixa li:nth-child(3) a');

  if (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();

      const btn = document.querySelector('.coder-comparable-button');
      if (btn) btn.click();
    });
  }
});
document.addEventListener("DOMContentLoaded", function () {
  if (window.location.pathname.includes("checkouts")) {
    window.location.href = "/";
  }
});


  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.sorting-filter__label').forEach(function (label) {
      label.textContent = label.textContent.replace('Alphabetically', 'SKU');
    });
  });

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.sorting-filter__select option').forEach(function (option) {
    option.textContent = option.textContent
      .replace('Alphabetically, A-Z', 'SKU, A-Z')
      .replace('Alphabetically, Z-A', 'SKU, Z-A');
  });
});
